export const generateSecureRandom = () => new Uint8Array([1,2,3,4]);
